statPushPost()
function statPushPost(params) {
    // if (process.env.NODE_ENV == 'development') {
    //   return false;
    // }
    console.log(document.location.href, 'xinxinxin');
  
    if (!params) {
      params = {
        "url": document.location.href,
        'appSecret': 'ca555646803f1ac7036cf92ca47be3c1',
        "appCode": "www_bjabia_org",
        "eventAction": "view",
        "eventCategory": "view",
      };
    } else if (!params.url) {
      params.url = document.location.href;
    }
    const headers = new Headers({
      'Content-Type': 'application/x-www-form-urlencoded',
    });
    const formData = new URLSearchParams(params);
  
    fetch('https://tongji.api.examok.com/api/tongji/push.json', {
      method: 'POST',
      headers: headers,
      body: formData
    })
      .then(response => response.json())
      .then(res => {
        if (res.data == 1) {
          console.log('统计成功');
        } else {
          // console.error(res.msg);
        }
      })
      .catch(error => {
        // console.error(error.message);
      });
  }